import {Component, OnInit} from '@angular/core';
import { Input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import {Subscription} from "rxjs";

@Component({
  standalone: true,
  selector: 'app-lb-chart-header',
  templateUrl: './lb-chart-header.component.html',
  styleUrls: ['./lb-chart-header.component.scss'],
  imports: [
    NgOptimizedImage
  ]
})
export class LbChartHeaderComponent {
  @Input() header: string = '';
  @Input() subheader: string = '';
  @Input() isEditMode: boolean = false;

}
